
exports.orderedObjectives = [
    'CONVERSIONS',
    'LINK_CLICKS',
    'REACH',
    'LEAD_GENERATION',
    'BRAND_AWARENESS',
    'PRODUCT_CATALOG_SALES',
    'VIDEO_VIEWS',
    'STORE_VISITS',
    'APP_INSTALLS',
    'EVENT_RESPONSES',
    'POST_ENGAGEMENT',
    'LOCAL_AWARENESS',
    'MESSAGES',
    'OFFER_CLAIMS',
    'PAGE_LIKES',
    'OUTCOME_SALES',
    'OUTCOME_LEADS'
];

exports.objectives = {
    APP_INSTALLS: 'Facebook App Installs',
    OUTCOME_SALES: 'Facebook Outcome Sales',
    BRAND_AWARENESS: 'Facebook Brand Awareness',
    CONVERSIONS: 'Facebook Conversions',
    EVENT_RESPONSES: 'Facebook Event Responses',
    LEAD_GENERATION: 'Facebook Lead Generation',
    LINK_CLICKS: 'Facebook Link Clicks',
    LOCAL_AWARENESS: 'Facebook Local Awareness',
    MESSAGES: 'Facebook Messages',
    OFFER_CLAIMS: 'Facebook Offer Claims',
    PAGE_LIKES: 'Facebook Page Likes',
    POST_ENGAGEMENT: 'Facebook Post Engagement',
    PRODUCT_CATALOG_SALES: 'Facebook Product Catalog Sales',
    REACH: 'Facebook Reach',
    STORE_VISITS: 'Facebook Store Visits',
    VIDEO_VIEWS: 'Facebook Video Views',
    OUTCOME_LEADS: 'Facebook Outcome Leads',
    N_A: '--'
};



// WEBPACK FOOTER //
// ./src/constants/facebook.js